// extracted by mini-css-extract-plugin
export default {"attributes":"Attributes_attributes__a5cBM"};